<p>amount-report works!</p>
